/**
 * API Configuration Utility for Receipt Scanner Integration
 * Version: 1.0.2
 */
console.log('apiConfig.js loaded - Version 1.0.2');
// Determine the base URL for the Receipt Scanner API based on the environment
export const getReceiptScannerBaseUrl = () => {
  // Check if we're in a browser environment
  if (typeof window !== 'undefined') {
    // For client-side code - use direct Firebase Functions URL for all domains
    // CORS is now properly handled on the server side
    return process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_RECEIPT_SCANNER_API_URL || 'https://us-central1-beautyfinancetracker.cloudfunctions.net'
      : 'https://us-central1-beautyfinancetracker.cloudfunctions.net';
  } else {
    // For server-side code
    return process.env.NODE_ENV === 'production'
      ? process.env.RECEIPT_SCANNER_API_URL || 'https://us-central1-beautyfinancetracker.cloudfunctions.net'
      : 'https://us-central1-beautyfinancetracker.cloudfunctions.net';
  }
};
// API endpoints
export const API_ENDPOINTS = {
  STATUS: '/api/v2/beauty-finance/status',      // API router path
  UPLOAD_WITH_OCR: '/api/v2/beauty-finance/receipts',  // API router path
  EXPORT_RECEIPTS_ZIP: '/api/v2/beauty-finance/receipts/export-zip', // API router path
  RECEIPTS: '/scanReceipt',             // Direct function name (requires auth)
  RECEIPT_DETAILS: (id) => `/api/v2/beauty-finance/receipts/${id}`,  // API router path
  CONVERT_RECEIPT: (id) => `/api/v2/beauty-finance/receipts/${id}/convert`,  // API router path
  TIMESTAMP: Date.now()
};
// Get a full API URL
export const getApiUrl = (endpoint) => {
  const baseUrl = getReceiptScannerBaseUrl();
  
  // Regular URL construction
  return `${baseUrl}${endpoint}`;
};
// Default API headers
export const getDefaultHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};
